import CloseIcon from "@/assets/icons/close.svg"
import SmileIcon from "@/assets/icons/smile.png"
import { type FormEvent, useState } from "react"

interface Props {
  open: boolean
  onClose: (value: false) => void
  sendFeedback: (text: string) => void
}

export function FeedbackModal(props: Props) {
  const { open, onClose, sendFeedback } = props

  const [text, setText] = useState("")

  const submithandler = (event: FormEvent) => {
    event.preventDefault()
    sendFeedback(text)
  }

  if (!open) return null

  return (
    <div className="absolute inset-0 z-[1] flex justify-center items-center bg-[#3d3d3c98] backdrop-blur-sm">
      <div className="relative p-5 w-[calc(100%-2rem)] bg-[#1f1f1f] rounded-2xl shadow-lg">
        <button
          onClick={() => onClose(false)}
          className="absolute top-0 right-0 !w-12 !h-12 flex justify-center items-center bg-[#3d3c3c9a] rounded-tr-xl rounded-bl-xl"
        >
          <CloseIcon className="!w-5 !h-5 fill-[#ffffff]" />
        </button>
        <div className="flex items-end gap-2 !mb-5 text-[22px] text-[#ffffff]">
          Расскажите,
          <br />
          что вам не понравилось? <img src={SmileIcon} className="!w-6 !h-6" />
        </div>
        <form onSubmit={submithandler} className="flex flex-col gap-5">
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Что мы можем улучшить?.."
            className="!py-3 !px-4 !h-[90px] !border !border-[#434343] rounded-xl resize-none placeholder:text-[#8c8c8c] !text-[16px] text-[#ffffff]"
          />
          <button
            type="submit"
            disabled={!text}
            className="w-full h-12 bg-gradient button-shadow text-[#ffffff] rounded-xl text-[16px] disabled:opacity-50 disabled:cursor-not-allowed! hover:opacity-70 transition-opacity duration-300"
          >
            Отправить
          </button>
        </form>
      </div>
    </div>
  )
}
